import { api } from '../axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetOrderDetailResponse } from '../type/types';

interface getOrderDetailProps {
  orderId: string;
}
export const getOrderDetail = async ({ orderId }: getOrderDetailProps) => {
  const res = await api.get<ApiResponseType<GetOrderDetailResponse>>(
    `/api/web/partners/orders/${orderId}`
  );
  return res.data;
};
